import React, { ChangeEvent } from 'react';

import { DelimitedInput } from 'components/DelimitedInput/DelimitedInput';
import { LegacyInput } from 'components/LegacyInput';
import { CURRENCIES } from 'utils/constants/currency';

import {
  CurrencyInputContainer,
  CurrencyInputSign,
} from './CurrencyInput.styled';

type Props = {
  type?: string;
  'data-qa-id': string;
  id?: string;
  hasError?: boolean;
  name?: string;
  value?: string | number;
  placeholder?: string;
  errorMessage?: string;
  min?: number | string;
  max?: number | string;
  step?: string;
  required?: boolean;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  currencyCode?: keyof typeof CURRENCIES;
};

export function CurrencyInput({
  type,
  'data-qa-id': dataQaId,
  id,
  hasError,
  name,
  value,
  placeholder,
  errorMessage,
  min,
  max,
  step,
  required,
  onChange,
  currencyCode,
}: Props) {
  const InputComponent = type === 'number' ? LegacyInput : DelimitedInput;
  const currency = currencyCode && CURRENCIES[currencyCode];

  return (
    <CurrencyInputContainer>
      {currency && <CurrencyInputSign>{currency.sign}</CurrencyInputSign>}

      <InputComponent
        height="100%"
        width="100%"
        pl={
          // The padding is adjusted based on the length of the sign
          // so that the sign is not on top of the input value.
          currency ? `${18 + currency.sign.length * 14}px` : undefined
        }
        type={type}
        data-qa-id={dataQaId}
        id={id}
        hasError={hasError}
        name={name}
        value={value}
        placeholder={placeholder}
        errorMessage={errorMessage}
        min={min}
        max={max}
        step={step}
        required={required}
        onChange={onChange}
      />
    </CurrencyInputContainer>
  );
}
